var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useContext, useEffect } from "react";
import { MapStateContext } from "../components/context/map-state-context";
import { usePatchableState } from "./use-patchable-state";
export var useMapState = function useMapState() {
  return usePatchableState(useContext(MapStateContext));
};
export var useMapUtils = function useMapUtils() {
  var _a = __read(useMapState(), 3),
      _b = _a[0],
      state = _b === void 0 ? {} : _b,
      setState = _a[1],
      patchState = _a[2];

  var selectedEntity = state.selectedEntity,
      isVisible = state.isVisible;

  var toggleSelectedEntity = function toggleSelectedEntity(entity) {
    patchState({
      selectedEntity: selectedEntity && selectedEntity.id === entity.id ? null : entity
    });
  };

  var toggle = function toggle() {
    patchState({
      isVisible: !isVisible
    });
  };

  var show = function show(withState) {
    patchState(__assign(__assign({}, withState || {}), {
      isVisible: true
    }));
  };

  var hide = function hide(options) {
    if (options === void 0) {
      options = {
        deselect: false
      };
    }

    patchState({
      isVisible: false,
      selectedEntity: options.deselect ? null : selectedEntity
    });
  };

  var toggleOnClick = function toggleOnClick(e) {
    e.preventDefault();
    toggle();
  };

  var hideOnClick = function hideOnClick(e) {
    e.preventDefault();
    hide();
  };

  var showOnClick = function showOnClick(e) {
    e.preventDefault();
    show();
  };

  var deselect = function deselect() {
    patchState({
      selectedEntity: null
    });
  };

  var init = function init() {
    useEffect(function () {
      if (isVisible) {
        patchState({
          isInitialized: true
        });
      }
    }, [isVisible]);
  };

  var showEntity = function showEntity(entity, options) {
    if (options === void 0) {
      options = {
        showMap: true
      };
    }

    var zoom = options.zoom,
        showMap = options.showMap,
        entityTypeNames = options.entityTypeNames;
    patchState({
      isVisible: showMap ? true : isVisible,
      selectedEntity: options.select ? entity : options.deselect ? null : selectedEntity,
      latitude: entity.latitude,
      longitude: entity.longitude,
      entityTypeNames: entityTypeNames,
      zoom: zoom
    });
  };

  var showEntityTypes = function showEntityTypes(entityTypeNames, withState, options) {
    if (withState === void 0) {
      withState = {};
    }

    patchState(__assign(__assign({}, withState), {
      isVisible: true,
      entityTypeNames: entityTypeNames
    }));
  };

  return __assign({
    show: show,
    hide: hide,
    toggle: toggle,
    showMap: show,
    hideMap: hide,
    toggleMap: toggle,
    toggleOnClick: toggleOnClick,
    showOnClick: showOnClick,
    hideOnClick: hideOnClick,
    showEntityTypes: showEntityTypes,
    toggleSelectedEntity: toggleSelectedEntity,
    showEntity: showEntity,
    deselect: deselect,
    init: init
  }, state);
};